module.exports = __webpack_public_path__ + "img/MoFoto3.500128d3.jpg";